import { StyleSheet, Modal as ModalLib, ModalProps, Platform, Pressable } from 'react-native';
import { BlurView } from 'expo-blur';

import { spacing } from '../../../theme';

export const ModalBackdrop = ({ children, onPress, ...modalProps }: ModalBackdropProps) => {
	return (
		<ModalLib {...modalProps} transparent supportedOrientations={['portrait', 'landscape']}>
			<Pressable onPress={onPress} style={styles.pressContainer}>
				<BlurView tint="dark" intensity={Platform.OS === 'android' ? 70 : 30} style={styles.blur}>
					{children}
				</BlurView>
			</Pressable>
		</ModalLib>
	);
};

const styles = StyleSheet.create({
	pressContainer: {
		flex: 1,
	},
	blur: {
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		padding: spacing(2),
	},
});

export interface ModalBackdropProps extends ModalProps {
	onPress?: () => void;
}
